import React from "react";
import { useEffect } from "react";
import APIConfig from "../../api/APIConfig";
import Form from "react-validation/build/form";
import { isEmail } from "validator";
import AuthService from "../../services/auth.service";
import Input from "react-validation/build/input";
import {
    Heading,
    FormControl,
    FormLabel,
    Button,
    InputRightElement,
    Stack,
    Box,
    Select,
    VStack,
  } from '@chakra-ui/react'
import { useState } from 'react';
import { ViewIcon, ViewOffIcon } from '@chakra-ui/icons';
import { LightBg, ParentCard, Card } from "./style";
import { useNavigate, useParams } from "react-router-dom"
import swal from 'sweetalert';

const required = value => {
    if (!value) {
      return (
        <div className="alert alert-danger" role="alert" style={{height: '30px',paddingTop: '2px'}}>
          Harus diisi!
        </div>
      );
    }
};

const email = value => {
    if (!isEmail(value)) {
        return (
        <div className="alert alert-danger" role="alert" style={{height: '30px',paddingTop: '2px'}}>
            Email tidak valid!
        </div>
        );
    }
};

const vpassword = value => {
    if (value.length <= 8) {
        return (
        <div className="alert alert-danger" role="alert" style={{height: '30px',paddingTop: '2px'}}>
            Password harus lebih dari 8 karakter!
        </div>
        );
    }
};

const RegisterMentor = () => {
    let navigate = useNavigate();

    const [showPassword, setShowPassword] = useState(false);
    const [successful, setSuccessful] = useState(false);
    const [message, setMessage] = useState("");
    const [emailUser, setEmailUser] = useState("");
    const [password, setPassword] = useState("");
    const [namaMentor, setNamaMentor] = useState("");

    const [mitra, setMitra] = useState([]);
    const [idProposal, setIdProposal] = useState(0);
    const [listProposal, setListProposal] = useState([]);

    const { id } = useParams();


    const getMitraById = async() => {
        const response = await APIConfig.get(`/v1/mitra/${id}`);
        const data = await response.data
        setMitra(data);
    };

    const getListProposal = async() => {
        const response = await APIConfig.get(`/v1/proposal/diterima/mitra/${id}`);
        const data = await response.data
        setListProposal(data);
    };

    useEffect(() => {
        getMitraById();
        getListProposal();
    }, []);

    const handleRegisterMentor = async (e) => {
        e.preventDefault();
        console.log(idProposal);
        try {
            const response = await APIConfig.get(`/v1/proposal/${idProposal}`);
            const data = await response.data
            if(namaMentor.length > 0 && password.length > 8) {
                await AuthService.registerMentor(
                    emailUser,
                    password,
                    namaMentor,
                    mitra,
                    data
                    ).then(
                    () => {
                        console.log(emailUser)
                        setSuccessful(true)
                        swal({
                            title: "Mentor telah berhasil ditambahkan",
                            icon: "success",
                            button: "OK",
                        }).then(() => {
                            navigate(`/mitra/profile/mentor/list-mentor/${id}`);
                        })
                    },
                    (error) => {
                        console.log(emailUser)
                        console.log(namaMentor)
                        console.log(mitra)
                        console.log(error);
    
                        let resMessage;
    
                        resMessage = (error.response &&
                                error.response.data &&
                                error.response.data.message) ||
                            error.message ||
                            error.toString();
    
                            console.log(resMessage);
    
                        if(resMessage.includes("could not execute statement; SQL [n/a]; constraint [UK_5fxlusj9c11kvgahypos561pv]; nested exception is org.hibernate.exception.ConstraintViolationException: could not execute statement")) {
                            swal({
                                title: "Mentor gagal ditambahkan!",
                                text: "Email belum diisi atau telah terdaftar. Silakan coba lagi!",
                                icon: "error",
                                button: "OK",
                            })
                        } else {
                            swal({
                                title: "Mentor gagal ditambahkan!",
                                text: "Email belum diisi atau telah terdaftar. Silakan coba lagi!",
                                icon: "error",
                                button: "OK",
                            })
                        }
                        setSuccessful(false);
                    }
                );
            }
            else {
                swal({
                    title: "Mentor gagal ditambahkan!",
                    text: "Pastikan data mentor sudah lengkap!",
                    icon: "error",
                    button: "OK",
                })
            }
        } catch (err) {
          console.log(err);
        }
    };

    return (
        <>
        <LightBg>
            <ParentCard>
                <Card>
                    <Stack>
                        <Box>
                            <Heading paddingBottom={10} textAlign={'center'} fontFamily={'Inter'}>Tambahkan Mentor</Heading>
                        </Box>
                        <Form 
                        onSubmit={handleRegisterMentor}>
                            <Box> 
                                <VStack spacing={4} align='stretch' p={3}>
                                    <FormControl isRequired fontFamily={'Inter'}>
                                    <FormLabel htmlFor='namaMentor'>Nama mentor</FormLabel>
                                        <Input 
                                        style={{paddingLeft: "8px", paddingTop: "6px", paddingBottom: "6px", border: '1px solid #F5F5F5', borderRadius: '5px', width: '100%', height:'40px'}}
                                        id='namaMentor' 
                                        placeholder='Masukkan nama mentor'
                                        value={namaMentor}
                                        onChange={(e) => setNamaMentor(e.target.value)}
                                        validations={[required]} />
                                    </FormControl>

                                    <FormControl pb={6} isRequired fontFamily={'Inter'}>
                                    <FormLabel htmlFor='idProposal'>Proposal</FormLabel>
                                    <Select
                                    style={{paddingLeft: "8px", paddingTop: "6px", paddingBottom: "6px", border: '1px solid #F5F5F5', borderRadius: '5px', width: '100%', height:'40px'}} 
                                    id='idProposal' 
                                    value={idProposal}
                                    onChange={(e) => setIdProposal(e.target.value)}
                                    placeholder="--Pilih--">
                                        {listProposal.map((data) => {
                                            return <option value={data.idProposal}>{data.namaProposal}</option>
                                        })}
                                    </Select>
                                    </FormControl>

                                    <FormControl isRequired fontFamily={'Inter'}>
                                    <FormLabel htmlFor='emailUser'>Email</FormLabel>
                                        <Input 
                                        id='emailUser' 
                                        style={{paddingLeft: "8px", paddingTop: "6px", paddingBottom: "6px", border: '1px solid #F5F5F5', borderRadius: '5px', width: '100%', height:'40px'}}
                                        placeholder='Masukkan alamat email'
                                        value={emailUser}
                                        onChange={(e) => setEmailUser(e.target.value)}
                                        validations={[email, required]} />
                                    </FormControl>

                                    <FormControl id='password' isRequired fontFamily={'Inter'}>
                                    <FormLabel htmlFor='katasandi'>Kata sandi</FormLabel>
                                        <div>
                                            <Input
                                            style={{paddingLeft: "8px", paddingTop: "6px", paddingBottom: "6px", border: '1px solid #F5F5F5', borderRadius: '5px', width: '100%', height:'40px'}} 
                                            type={showPassword ? 'text' : 'password'} 
                                            placeholder='Masukkan kata sandi'
                                            value={password}
                                            onChange={(e) => setPassword(e.target.value)}
                                            validations={[vpassword, required]}/>
                                            <InputRightElement h={'full'}>
                                                <Button
                                                    variant={'ghost'}
                                                    onClick={() =>
                                                    setShowPassword((showPassword) => !showPassword)
                                                    }>
                                                    {showPassword ? <ViewIcon /> : <ViewOffIcon />}
                                                </Button>
                                            </InputRightElement>
                                        </div>
                                    </FormControl>
                                </VStack>
                            </Box>
                            <Box fontFamily={'Inter'} align={'center'}>
                                {message && (
                                    <div pb={5} className="form-group">
                                        <div 
                                        className={
                                            successful
                                            ? "alert alert-success"
                                            : "alert alert-danger"
                                        } 
                                        role="alert">
                                        {message}
                                        </div>
                                    </div>
                                )} 
                                <Button style={{background:'#6554C0', color:'#FFFFFF', justifyContent:'center'}} mt={4} type='submit'>Tambahkan</Button>
                            </Box>
                        </Form>
                    </Stack>
                </Card>
            </ParentCard>
        </LightBg>
        </>
    );
}


export default RegisterMentor;